"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfig = exports.initBootstrap = void 0;
const window_or_global_1 = __importDefault(require("window-or-global"));
let bootstrapObject = null;
function initBootstrap(dataPreload) {
    bootstrapObject = {};
    if (dataPreload && dataPreload.messageProperties) {
        bootstrapObject.LocalizationStore = {
            messages: dataPreload.messageProperties,
            loaded: true,
            supportedLocales: dataPreload.supportedLocales,
            locale: dataPreload.locale
        };
    }
    return bootstrapObject;
}
exports.initBootstrap = initBootstrap;
function getConfig(localizationData) {
    // Server-side rendering.  Use the object passed in.  In the browser, use the root object on the window.
    if (localizationData) {
        return initBootstrap(localizationData);
    }
    const localizationBootstrap = window_or_global_1.default['__epic-react-localization'];
    if (!localizationBootstrap) {
        console.log('Epic Localization Bootstrap did not find preload data on the window (__epic-react-localization), messages cannot be initialized.');
        return {};
    }
    if (bootstrapObject === null)
        initBootstrap(localizationBootstrap);
    return bootstrapObject;
}
exports.getConfig = getConfig;
//# sourceMappingURL=Bootstrap.js.map